define('apps/course-intro/templates/items/badge',['handlebars'], function(Handlebars) {

return Handlebars.template(function (Handlebars,depth0,helpers,partials,data) {
  this.compilerInfo = [4,'>= 1.0.0'];
helpers = this.merge(helpers, Handlebars.helpers); data = data || {};
  var buffer = "", stack1, functionType="function", escapeExpression=this.escapeExpression, self=this;

function program1(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n\n        <div class=\"badge-container ";
  stack1 = helpers.unless.call(depth0, (depth0 && depth0.isBadgeEarned), {hash:{},inverse:self.noop,fn:self.program(2, program2, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\">\n            <div class=\"badge-img player-asset\"\n                ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isBadgeEarned), {hash:{},inverse:self.noop,fn:self.program(4, program4, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n                ></div>\n        </div>\n\n        <p class=\"module-title\">";
  if (stack1 = helpers.title) { stack1 = stack1.call(depth0, {hash:{},data:data}); }
  else { stack1 = (depth0 && depth0.title); stack1 = typeof stack1 === functionType ? stack1.call(depth0, {hash:{},data:data}) : stack1; }
  buffer += escapeExpression(stack1)
    + "</p>\n\n    ";
  return buffer;
  }
function program2(depth0,data) {
  
  
  return "locked";
  }

function program4(depth0,data) {
  
  var buffer = "", stack1;
  buffer += "\n                    data-guid=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.badgeImage)),stack1 == null || stack1 === false ? stack1 : stack1.assetGuid)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-type-id=\""
    + escapeExpression(((stack1 = ((stack1 = (depth0 && depth0.badgeImage)),stack1 == null || stack1 === false ? stack1 : stack1.typeId)),typeof stack1 === functionType ? stack1.apply(depth0) : stack1))
    + "\" data-layout=\"background\"\n                ";
  return buffer;
  }

function program6(depth0,data) {
  
  
  return "\n\n        <div class=\"badge-container locked\">\n            <div class=\"badge-img\"></div>\n        </div>\n\n        <p class=\"module-title\">\n            <span class=\"fa fa-lock\"></span>\n        </p>\n\n    ";
  }

  buffer += "<section>\n    ";
  stack1 = helpers['if'].call(depth0, (depth0 && depth0.isUnlocked), {hash:{},inverse:self.program(6, program6, data),fn:self.program(1, program1, data),data:data});
  if(stack1 || stack1 === 0) { buffer += stack1; }
  buffer += "\n</section>\n";
  return buffer;
  })

});
